/*
 Auto-generated by generate-java-to-ts-maven-plugin. Do not edit.
 Source: de.mhus.vance.api.progress.StatusTag
*/
export var StatusTag;
(function (StatusTag) {
    StatusTag["TOOL_START"] = "TOOL_START";
    StatusTag["TOOL_END"] = "TOOL_END";
    StatusTag["SEARCH"] = "SEARCH";
    StatusTag["FETCH"] = "FETCH";
    StatusTag["FILE_WRITE"] = "FILE_WRITE";
    StatusTag["FILE_READ"] = "FILE_READ";
    StatusTag["DELEGATING"] = "DELEGATING";
    StatusTag["WAITING"] = "WAITING";
    StatusTag["PROVIDER"] = "PROVIDER";
    StatusTag["NODE_DONE"] = "NODE_DONE";
    StatusTag["PHASE_DONE"] = "PHASE_DONE";
    StatusTag["COMPACTION"] = "COMPACTION";
    StatusTag["ENGINE_TURN_START"] = "ENGINE_TURN_START";
    StatusTag["ENGINE_TURN_END"] = "ENGINE_TURN_END";
    StatusTag["ENGINE_HALT_REQUESTED"] = "ENGINE_HALT_REQUESTED";
    StatusTag["ENGINE_PAUSED"] = "ENGINE_PAUSED";
    StatusTag["ENGINE_RESUMED"] = "ENGINE_RESUMED";
    StatusTag["ENGINE_CLOSED"] = "ENGINE_CLOSED";
    StatusTag["SCRIPT_PROGRESS"] = "SCRIPT_PROGRESS";
    StatusTag["INFO"] = "INFO";
})(StatusTag || (StatusTag = {}));
//# sourceMappingURL=StatusTag.js.map